<template>
    <modal-dialog
        id="newsletter"
        :show.sync="shown"
        class="uk-modal-dialog-large"
    >
        <template v-slot:title>
            Lumen Launchpad (Week of {{ newsletter_date }})
        </template>
        <template v-slot:footer>
            <div class="uk-grid">
                <div class="uk-width-1-3">
                    <base-button
                        :disabled="saving_newsletter_notification"
                        size="large"
                        width="1-1"
                        :block="true"
                        @click.prevent="close"
                    >
                        Cancel
                    </base-button>
                </div>
                <div class="uk-width-1-3">
                    <base-button
                        :disabled="saving_newsletter_notification"
                        size="large"
                        width="1-1"
                        :block="true"
                        @click.prevent="send_newsletter_notification(true)"
                    >
                        Preview
                    </base-button>
                </div>
                <div class="uk-width-1-3">
                    <base-button
                        :waiting="saving_newsletter_notification"
                        :disabled="saving_newsletter_notification"
                        color="primary"
                        size="large"
                        width="1-1"
                        :block="true"
                        @click.prevent="send_newsletter_notification(false)"
                    >
                        {{ send_button_title }}
                    </base-button>
                    <div class="uk-flex uk-margin-small-top">
                        <label
                            class="uk-form-label uk-flex-item-none uk-margin-right uk-margin-small-top"
                        >
                            Send:
                        </label>
                        <form-date-input
                            id="send_at"
                            v-model="newsletter_notification.send_at"
                            name="send_at"
                            :required="false"
                            :min-date="1"
                            placeholder="Immediately"
                            class="uk-width-1-1"
                        />
            </div>
                </div>
            </div>
        </template>

        <form class="uk-form" role="form">
            <h4>Staffing Notes</h4>

            <div class="uk-grid">
                <div class="uk-width-1-2">
                    <h5 class="uk-text-uppercase">This Week</h5>
                    <editor v-model="newsletter_notification.content.this_week_notes" style="height: 300px;" />
                </div>
                <div class="uk-width-1-2">
                    <h5 class="uk-text-uppercase">Next Week</h5>
                    <editor v-model="newsletter_notification.content.next_week_notes" style="height: 300px;" />
                </div>
            </div>

            <h4>
                Deliverables
            </h4>
            <data-table
                :id="state_identifier"
                :columns="visible_columns"
                :rows="filtered_rows"
                :search="state.search"
                :total="state.total"
                :found="state.found"
                :current-page="state.page"
                :total-pages="nb_pages"
                :searchable="false"
                table-class="uk-table-condensed uk-table-hover lam-subrecords-list"
                empty-title="No deliverables found"
                @sort="sort_by"
                @search="search"
                @page="goto_page"
            >

                <template
                    v-slot:summary="{ row }"
                >
                    <h6>{{ row.name }}</h6>
                </template>
                <template
                    v-slot:tbody="{ row, field }"
                >
                    <span v-if="field === 'sortable_number'">{{ project_for_row(row).sortable_number | lam.project-number }} {{ project_for_row(row).name }}</span>
                    <span v-else-if="field === 'ends_at_as_string'">{{ row.ends_at_as_string | nibnut.date("dddd MM/DD") }}</span>
                    <span v-else-if="field.match(/^(studios|team)/)">{{ row[field].join(', ') }}</span>
                    <span v-else>{{ row[field] }}</span>
                </template>
            </data-table>

            <h4>Cheryl's Corner</h4>
            <editor v-model="newsletter_notification.content.conclusion" style="height: 300px;" />
        </form>
    </modal-dialog>
</template>

<script type="text/javascript">
import is_remote_data_table_source from "../mixins/IsRemoteDataTableSource"
import handles_newsletter_notification from "../mixins/HandlesNewsletterNotification"

import ModalDialog from "./ModalDialog/ModalDialog"
import FormDateInput from "../ui/FormDateInput"
import BaseButton from "../ui/BaseButton"
import Editor from "../ui/Editor"

export default {
    mixins: [is_remote_data_table_source, handles_newsletter_notification],
    components: {
        ModalDialog,
        FormDateInput,
        BaseButton,
        Editor
    },
    watch: {
        show: "load_newsletter_notification"
    },
    methods: {
        project_for_row (row) {
            if(!row) return {}
            return this.raw_project_records.find(project => project.id === row.project_id) || {}
        },
        sent_newsletter_notification () {
            this.close()
        },
        close () {
            this.$emit("update:show", false)
        }
    },
    computed: {
        shown: {
            get: function () {
                return this.show
            },
            set: function (show) {
                if(!show) this.close()
            }
        },
        raw_project_records () {
            return this.$store.getters.entity_records("project")
        },
        state_identifier () {
            return "newsletter-deliverables"
        },
        fields () {
            const fields = Object.keys(this.columns)
            fields.push("ns::project;fieldset::parent")
            return fields
        },
        visible_columns () {
            const { project_id, ...visible_columns } = this.columns
            return visible_columns
        },
        newsletter_date () {
            const newsletter_notification = this.newsletter_notification
            let date = this.$moment()
            if(!!newsletter_notification && !!newsletter_notification.send_at) date = this.$moment(newsletter_notification.send_at)
            return date.startOf("isoWeek").format("D MMMM YYYY")
        },
        send_button_title () {
            const newsletter_notification = this.newsletter_notification
            if(!!newsletter_notification && !!newsletter_notification.send_at) {
                const date = this.$moment(newsletter_notification.send_at)
                return `Schedule Send on ${date.format("D MMMM")}`
            }
            return "Send"
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            entity: "task",
            relation_ids: ["project"],
            columns: {
                ends_at_as_string: { label: "Due Date", sort: null, type: "plain" },
                sortable_number: { label: "Project # / Name", sort: null, type: "plain" },
                project_id: { label: "Project ID", sort: null, type: "plain" },
                title: { label: "Deadline", sort: false, type: "plain" },
                studios: { label: "Office(s)", sort: false, type: "plain", cell_class: "lam-col-fee" },
                team: { label: "Team", sort: false, type: "plain" }
            },

            default_state: {
                per_page: 10,
                page: 1,
                sort_by: "sortable_number",
                sort_dir: "asc",
                filter_on: null,
                filter: "",
                archived: false,
                search: "",
                total: 0,
                found: 0,
                context: "deliverables",
                activated_at: 0
            }
        }
    }
}
</script>
